import { useEffect, useState } from "react";
import { Tag } from "lucide-react";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { api, apiError } from "@/lib/api";

export function VersionCard({ isSuper }) {
  const [v, setV] = useState(null);
  const load = () => api.get("/system/version").then(({ data }) => setV(data));
  useEffect(() => { load(); }, []);
  const mark = async (version, production) => {
    try { await api.put(`/system/versions/${version}/production`, { production }); load(); } catch (e) { toast.error(apiError(e)); }
  };
  if (!v) return null;
  return (
    <div className="panel p-4" data-testid="version-card">
      <h3 className="font-semibold flex items-center gap-2 mb-2"><Tag className="h-4 w-4" />Sürüm Bilgisi · <span data-testid="app-version-current">v{v.current}</span></h3>
      <div className="divide-y divide-slate-100">
        {v.versions.map((x) => (
          <div key={x.version} className="py-2 flex items-start justify-between gap-3 text-[12px]" data-testid={`version-row-${x.version}`}>
            <div>
              <div className="font-semibold text-[13px]">v{x.version} · {x.title} <span className="text-slate-400 font-normal">{x.date}</span></div>
              <ul className="list-disc pl-5 text-slate-600">{x.items.map((i) => <li key={i}>{i}</li>)}</ul>
            </div>
            <label className="flex items-center gap-2 whitespace-nowrap text-slate-600">
              {isSuper && <Switch checked={x.production} onCheckedChange={(p) => mark(x.version, p)} data-testid={`version-production-${x.version}`} />}
              {x.production ? "Production" : "Test"}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
}
